import { render, staticRenderFns } from "./SkuInfo.vue?vue&type=template&id=9b266a70&scoped=true&"
import script from "./SkuInfo.vue?vue&type=script&lang=js&"
export * from "./SkuInfo.vue?vue&type=script&lang=js&"
import style0 from "./SkuInfo.vue?vue&type=style&index=0&id=9b266a70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b266a70",
  null
  
)

component.options.__file = "SkuInfo.vue"
export default component.exports